import { useFormState } from 'react-final-form';
const FormStateWrapper = ({ formRef, children }) => {
    const state = useFormState();
    return children(state, formRef);
};
export default FormStateWrapper;
